// extracted by mini-css-extract-plugin
module.exports = {"loginFooter":"Footer_loginFooter__3wKeR","footerLogo":"Footer_footerLogo__2KSJm"};